"use strict";

window.FoG = window.FoG || {};

window.FoG.Favorites = (function($) {
  var $favContainer;
  var $loadMoreBtn;
  var $favList;
  
  function onLoadMore(response) {
    var lmDef = FoG.loadMoreFavoritesDef;
    lmDef.loadingMore = false;

    var $favTemplate = $favList.find('li.cloneable');
    
    // Loop through articles and create/populate/append each one to the list
    $.each(response.favorites, function(dummyIdx, fav) {
      var $fav = $favTemplate.clone().removeClass('cloneable');
      
      $fav.find('.postTitle a').attr('href', fav.permalink).text(fav.title);
      $fav.find('.postAuthor').text(fav.author);
      $fav.find('.postDate').attr('datetime', fav['date-iso']).text(fav['date-display']);
      $favList.append($fav);
    });
    
    lmDef.hasMore = response.hasMore;
    lmDef.nextOffset = response.nextOffset;

    if (!lmDef.hasMore) {
      $loadMoreBtn.remove();
    }
  }

  
  function loadMore() {
    var lmDef = FoG.loadMoreFavoritesDef;
    
    if (!lmDef || !lmDef.hasMore) { 
      $loadMoreBtn.remove(); 
      return;
    }

    if (lmDef.loadingMore) { return; }
    
    lmDef.loadingMore = true;
    
    var params = {
      offset: lmDef.nextOffset
    }
    
    var fnResetLoadingMore = function() { lmDef.loadingMore = false; }
    
    NA.Ajax.get('favorites-loadMore', params, onLoadMore, fnResetLoadingMore);
  }
  
  
  function initLoadMore() {
    $favContainer = $('.activityContainer--favorites');
    $loadMoreBtn = $('.favorites__loadMore', $favContainer);
    $favList = $('.activityContainer__bookmarkList', $favContainer);

    $loadMoreBtn.on('click', loadMore);
  }
  
  return {
    initLoadMore: initLoadMore
  };
})(jQuery);